const map = {
	"./ModuleAiTools/AiVideoGenerator/registry/menu.js": 90364,
	"./ModuleCommunity/Course/registry/menu.js": 57475,
	"./ModuleCommunity/CourseLesson/registry/menu.js": 23831,
	"./ModuleCommunity/CourseReview/registry/menu.js": 25639,
	"./ModuleCommunity/CourseStudent/registry/menu.js": 52056,
	"./ModuleCommunity/FeaturedContent/registry/menu.js": 58871,
	"./ModuleCompany/BCBusinessSector/registry/menu.js": 35455,
	"./ModuleCompany/BCEconomicSector/registry/menu.js": 31152,
	"./ModuleCompany/BCIndustry/registry/menu.js": 77785,
	"./ModuleCompany/BCIndustryActivity/registry/menu.js": 92496,
	"./ModuleCompany/BCIndustryGroup/registry/menu.js": 8070,
	"./ModuleCompany/Company/registry/menu.js": 28045,
	"./ModuleCompany/ExtractFinanceStatement/registry/menu.js": 52724,
	"./ModuleCompany/GoldExchange/registry/menu.js": 74063,
	"./ModuleCompany/GoldSnapshot/registry/menu.js": 37238,
	"./ModuleCompany/NewsArticle/registry/menu.js": 79605,
	"./ModuleCompany/NewsSummary/registry/menu.js": 71075,
	"./ModuleCompany/PromptGenAi/registry/menu.js": 48016,
	"./ModuleCompany/SeIndexSnapshot/registry/menu.js": 12682,
	"./ModuleCompany/StockAnalysisReport/registry/menu.js": 44364,
	"./ModuleCore/AppReleaseNotices/registry/menu.js": 56305,
	"./ModuleCore/Billing/registry/menu.js": 40979,
	"./ModuleCore/BillingDetail/registry/menu.js": 86414,
	"./ModuleCore/BillingTransaction/registry/menu.js": 74203,
	"./ModuleCore/ConfigSystem/registry/menu.js": 36237,
	"./ModuleCore/ContactForm/registry/menu.js": 82162,
	"./ModuleCore/GlobalConfig/registry/menu.js": 97183,
	"./ModuleCore/IntegrationLog/registry/menu.js": 51114,
	"./ModuleCore/MembershipCashPlan/registry/menu.js": 86238,
	"./ModuleCore/MembershipPlan/registry/menu.js": 39165,
	"./ModuleCore/MembershipPlanUser/registry/menu.js": 76618,
	"./ModuleCore/MembershipSubscriptionUser/registry/menu.js": 90540,
	"./ModuleCore/MiniAppConfig/registry/menu.js": 37788,
	"./ModuleCore/Order/registry/menu.js": 8136,
	"./ModuleCore/PaymentMode/registry/menu.js": 23365,
	"./ModuleCore/PromotionCoupon/registry/menu.js": 6323,
	"./ModuleCore/PromotionCouponRedemption/registry/menu.js": 3362,
	"./ModuleCore/PromotionRule/registry/menu.js": 92179,
	"./ModuleCore/ReferralRegistration/registry/menu.js": 46738,
	"./ModuleCore/ReferralReward/registry/menu.js": 44088,
	"./ModuleCore/ReferralTransition/registry/menu.js": 15780,
	"./ModuleCore/ReferralWithdrawal/registry/menu.js": 29000,
	"./ModuleCore/ReferrerRewardPlan/registry/menu.js": 11933,
	"./ModuleCore/SecuritiesAccount/registry/menu.js": 2261,
	"./ModuleCore/SecuritiesAccountForm/registry/menu.js": 99279,
	"./ModuleCore/SecuritiesSubAccount/registry/menu.js": 81185,
	"./ModuleCore/Tenant/registry/menu.js": 88006,
	"./ModuleCore/TenantAuthConfig/registry/menu.js": 16030,
	"./ModuleCore/TenantUserMapping/registry/menu.js": 13003,
	"./ModuleCore/TenantWebhook/registry/menu.js": 43853,
	"./ModuleCore/User/registry/menu.js": 97849,
	"./ModuleCore/UserCash/registry/menu.js": 79286,
	"./ModuleCore/UserCashDetail/registry/menu.js": 9275,
	"./ModuleCore/UserCashPlan/registry/menu.js": 29865,
	"./ModuleCore/UserCashTransaction/registry/menu.js": 75812,
	"./ModuleCore/UserForceSession/registry/menu.js": 12828,
	"./ModuleCore/UserLoginActivity/registry/menu.js": 66685,
	"./ModuleCore/UserReferral/registry/menu.js": 62180,
	"./ModuleCore/UserReferralPlan/registry/menu.js": 89683,
	"./ModuleCore/UserReferralReward/registry/menu.js": 94923,
	"./ModuleCrm/CampaignSale/registry/menu.js": 94324,
	"./ModuleCrm/CampaignZone/registry/menu.js": 77621,
	"./ModuleCrm/CompanyReport/registry/menu.js": 57024,
	"./ModuleCrm/ContentTemplate/registry/menu.js": 49010,
	"./ModuleCrm/CustomField/registry/menu.js": 63900,
	"./ModuleCrm/PopupInfo/registry/menu.js": 70471,
	"./ModuleCrm/PopupUser/registry/menu.js": 2912,
	"./ModuleCrm/SegmentUser/registry/menu.js": 40431,
	"./ModuleCrm/Segments/registry/menu.js": 31199,
	"./ModuleCrm/TagUser/registry/menu.js": 53366,
	"./ModuleCrm/Tags/registry/menu.js": 33956,
	"./ModuleCrm/UserFeedback/registry/menu.js": 93313,
	"./ModuleCrm/UserInfo/registry/menu.js": 74462,
	"./ModuleCrm/WallOfLove/registry/menu.js": 89424,
	"./ModuleCrm/WorkflowTrigger/registry/menu.js": 72486,
	"./ModuleCrm/WorkflowTriggerUser/registry/menu.js": 46937,
	"./ModuleCrm/Zone/registry/menu.js": 29835,
	"./ModuleDashboard/ModuleDashboard/registry/menu.js": 64505,
	"./ModuleFileManager/FileManager/registry/menu.js": 69301,
	"./ModuleNotification/NotificationModule/registry/menu.js": 76117,
	"./ModuleNotification/NotificationMsgTemplate/registry/menu.js": 42278,
	"./ModuleNotification/NotificationSetting/registry/menu.js": 14725,
	"./ModuleNotification/NotificationSnapshot/registry/menu.js": 59141,
	"./ModuleNotification/NotificationType/registry/menu.js": 79865,
	"./ModuleNotification/NotificationTypeGroup/registry/menu.js": 84614,
	"./ModuleNotification/OtpTracking/registry/menu.js": 22108,
	"./ModuleNotification/SmSubscribeTracking/registry/menu.js": 91977,
	"./ModuleNotification/SmsTrackingLog/registry/menu.js": 53652,
	"./ModulePersonalize/CompanyNote/registry/menu.js": 61700,
	"./ModulePersonalize/IntegrationLog/registry/menu.js": 34251,
	"./ModulePersonalize/NebulaBrainDailyTrade/registry/menu.js": 479,
	"./ModulePersonalize/NebulaBrainHistory/registry/menu.js": 23212,
	"./ModulePersonalize/NebulaDecisionTemplates/registry/menu.js": 18635,
	"./ModulePersonalize/NebulaDecisions/registry/menu.js": 3717,
	"./ModulePersonalize/NebulaHoldings/registry/menu.js": 13288,
	"./ModulePersonalize/NebulaManagementFee/registry/menu.js": 41615,
	"./ModulePersonalize/NebulaMetadata/registry/menu.js": 89541,
	"./ModulePersonalize/NebulaOrders/registry/menu.js": 58553,
	"./ModulePersonalize/NebulaPerfFeeAmortized/registry/menu.js": 52844,
	"./ModulePersonalize/NebulaPerformance/registry/menu.js": 78176,
	"./ModulePersonalize/NebulaPerformanceFee/registry/menu.js": 50702,
	"./ModulePersonalize/NebulaPerformanceLog/registry/menu.js": 67552,
	"./ModulePersonalize/NebulaPositions/registry/menu.js": 17354,
	"./ModulePersonalize/NebulaProfile/registry/menu.js": 49251,
	"./ModulePersonalize/NebulaRewardTransaction/registry/menu.js": 69891,
	"./ModulePersonalize/NebulaStatistics/registry/menu.js": 2591,
	"./ModulePersonalize/NebulaTradingTransaction/registry/menu.js": 39407,
	"./ModulePersonalize/NebulaTransactions/registry/menu.js": 81177,
	"./ModulePersonalize/NebulaUltraFees/registry/menu.js": 48629,
	"./ModulePersonalize/NebulaUltraLog/registry/menu.js": 74972,
	"./ModulePersonalize/NebulaUltraMetadata/registry/menu.js": 82413,
	"./ModulePersonalize/NebulaUltraPlan/registry/menu.js": 811,
	"./ModulePersonalize/NebulaUltraTransactions/registry/menu.js": 10833,
	"./ModulePersonalize/NebulaUserProfile/registry/menu.js": 64134,
	"./ModulePersonalize/NebulaUserProfileHistory/registry/menu.js": 9216,
	"./ModulePersonalize/PnlConfigSystem/registry/menu.js": 9394,
	"./ModulePersonalize/PortfolioList/registry/menu.js": 91731,
	"./ModulePersonalize/PortfolioStock/registry/menu.js": 45345,
	"./ModulePersonalize/PortfolioSub/registry/menu.js": 2557,
	"./ModulePersonalize/PortfolioWallet/registry/menu.js": 40738,
	"./ModulePersonalize/PortfolioWalletMarginHistory/registry/menu.js": 40562,
	"./ModulePersonalize/TaIndicatorConfig/registry/menu.js": 45410,
	"./ModulePersonalize/TaSignalConfig/registry/menu.js": 12442,
	"./ModulePersonalize/UserScreener/registry/menu.js": 68343,
	"./ModulePersonalize/UserScreenerClient/registry/menu.js": 40352,
	"./ModulePersonalize/UserWorkspace/registry/menu.js": 45371,
	"./ModulePersonalize/Watchlist/registry/menu.js": 77080,
	"./ModulePersonalize/WatchlistItem/registry/menu.js": 56071,
	"./ModuleRole/Permission/registry/menu.js": 79424,
	"./ModuleRole/PermissionGroup/registry/menu.js": 48109,
	"./ModuleRole/PermissionGroupMapping/registry/menu.js": 64271,
	"./ModuleRole/PermissionGroupUser/registry/menu.js": 73690,
	"./ModuleRole/UserAuthority/registry/menu.js": 21895,
	"./ModuleRole/UserAuthorityMapping/registry/menu.js": 29733,
	"./ModuleSearch/WidgetDocumentSearch/registry/menu.js": 518
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70175;